export default __webpack_public_path__ + "static/media/img4.e52b92a0.png";